// extracted by mini-css-extract-plugin
export default {"skill":"skill_skill__XA3u-"};